<template>
  <v-container grid-list-md>
    <pi-progress v-if="progress" main></pi-progress>
    <pi-navigation :navigation="navigation"></pi-navigation>
    <v-layout row wrap>
      <v-flex sm6>
        <v-layout row wrap>
          <v-flex>
            <v-card>
              <v-subheader>Informacje</v-subheader>
              <v-card-text>
                <v-form ref="infoForm" lazy-validation>
                  <v-text-field
                    v-model="groupInfo.name"
                    :rules="Rules.group.name"
                    :disabled="progress"
                    required
                    prepend-icon="person"
                    name="name"
                    label="Nazwa"
                  ></v-text-field>
                  <v-autocomplete
                    :items="Rules.colors"
                    v-model="groupInfo.color"
                    :rules="Rules.group.color"
                    :disabled="progress"
                    required
                    prepend-icon="color_lens"
                    name="color"
                    label="Kolor"
                    menu-props="auto"
                    :color="groupInfo.color"
                    :class="'v-input--is-focused '+groupInfo.color+'--text'"
                  >
                    <template v-slot:item="data">
                      <v-list-tile-action>
                        <v-icon :color="data.item">color_lens</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>{{ data.item }}</v-list-tile-content>
                    </template>
                  </v-autocomplete>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12>
            <v-card>
              <v-subheader>Uprawnienia repozytorium</v-subheader>
              <v-card-text>
                <v-treeview
                  v-model="selectedFileTreeList"
                  :items="fileTreeList"
                  :open="fileTreeList.length > 0 ? [fileTreeList[0].id] : []"
                  :selectable="(Permissions.REPOSITORY_FULL & computedPermissions) == 0"
                  item-key="id"
                ></v-treeview>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex sm6>
        <v-card>
          <v-subheader>Uprawnienia</v-subheader>
          <v-card-text>
            <v-treeview
              v-model="selectedPermissionsList"
              :items="PermissionsTable"
              selectable
              :open="[Permissions.ADMIN, ...PermissionsTable[0].children.map(c => c.permition)]"
              item-key="permition"
            ></v-treeview>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-btn color="accent" dark bottom right fab fixed @click="setData()">
      <v-icon>save</v-icon>
    </v-btn>
    <pi-snackbar :color="snackbar.color" :snackbar.sync="snackbar.on" :message="snackbar.message"></pi-snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    progress: false,
    snackbar: { on: false, color: "error", message: "" },
    groupInfo: {
      name: "",
      color: "teal",
      permissions: 0
    },
    groupOriginal: {},
    createId: 0,
    selectedPermissionsList: [],
    navigation: [],
    fileTrees: [],
    fileTreeList: [],
    selectedFileTreeList: [],
    fileTreeRightTranslate: []
  }),
  computed: {
    groupId() {
      return this.isCreating ? this.createId : this.$route.params.groupId;
    },
    computedPermissions() {
      let r =
        this.selectedPermissionsList.length > 0
          ? this.selectedPermissionsList.reduce((s, v) => s | v)
          : 0;
      return r == -1 ? this.Permissions["ADMIN"] : r;
    },
    computedRights() {
      let r = [];
      for (let s of this.selectedFileTreeList) {
        if (s < 0) continue;
        let id = r.findIndex(
          r => r.fileTreeId == this.fileTreeRightTranslate[s][0]
        );
        let obj = {
          fileTreeId: this.fileTreeRightTranslate[s][0],
          right: this.fileTreeRightTranslate[s][1]
        };
        if (id >= 0) {
          obj = r[id];
          obj.right = obj.right | this.fileTreeRightTranslate[s][1];
        } else r.push(obj);
      }
      for (let t of this.fileTrees) {
        if (r.findIndex(r => r.fileTreeId == t.id) >= 0) continue;
        let obj = {
          fileTreeId: t.id,
          right: 0
        };
        r.push(obj);
      }
      return r;
    },
    groupData() {
      return {
        name: this.groupInfo.name,
        color: this.groupInfo.color,
        permissions: this.computedPermissions,
        rights: this.computedRights
      };
    }
  },
  props: { isCreating: Boolean },
  methods: {
    async getData() {
      this.progress = true;
      const responseFt = await this.Api.send("get", `/filetrees`);
      if (responseFt.status) this.fileTrees = responseFt.fileTrees;
      if (this.isCreating) {
        this.progress = false;
        return;
      }
      const response = await this.Api.send("get", `/groups/${this.groupId}`);

      this.progress = false;
      if (response.status) {
        this.groupInfo = { ...response.group };
        this.groupOriginal = { ...response.group };
        this.selectedPermissionsList = Object.keys(this.Permissions)
          .map(k => this.Permissions[k])
          .filter(p => (p & response.group.permissions) == p);
        return;
      }
      this.showError(response.message);
    },
    async setData() {
      if (!this.$refs.infoForm.validate()) {
        this.showError("Uzupełnij wymagane pola");
        return;
      }
      this.progress = true;
      const method = this.isCreating ? "post" : "put";
      const url = this.isCreating ? "/groups" : `/groups/${this.groupId}`;
      const response = await this.Api.send(method, url, {
        groupData: this.groupData
      });
      this.progress = false;
      if (response.status) {
        this.showSuccess(this.isCreating ? "Grupa dodana" : "Dane zmienione");
        this.getData();
        if (this.isCreating) this.$router.push({ path: "/group/all" });
        return;
      }
      this.showError(response.message);
    },
    async createNavigation() {
      this.navigation = [
        { id: 0, text: "Grupy", href: "/group/all" },
        this.isCreating
          ? {
              id: 1,
              text: "Tworzenie grupy",
              href: "/group/create",
              disabled: true
            }
          : {
              id: 1,
              text: `Edycja danych grupy ${this.groupOriginal.name}`,
              href: `/group/${this.groupId}/edit`,
              disabled: true
            }
      ];
    },
    async createFolderList() {
      let fileTreeList = [{ name: "Repozytorium", id: -1, children: [] }];
      this.fileTreeRightTranslate = [];
      let id = 0;
      for (let t of this.fileTrees) {
        if (t.id == 0) continue;
        this.fileTreeRightTranslate[id] = [t.id, 1];
        this.fileTreeRightTranslate[id + 1] = [t.id, 2];
        this.fileTreeRightTranslate[id + 2] = [t.id, 4];
        this.fileTreeRightTranslate[id + 3] = [t.id, 7];
        let o = {
          name: t.name,
          id: id + 3,
          children: [
            {
              name: "Odczyt",
              id: id
            },
            {
              name: "Dodawanie",
              id: id + 1
            },
            {
              name: "Usuwanie",
              id: id + 2
            }
          ]
        };
        fileTreeList[0].children.push(o);
        id += 4;
      }
      this.fileTreeList = fileTreeList;
      this.selectedFileTreeList = [];
      if (this.isCreating) return;
      for (let groupRight of this.groupInfo.GroupRights) {
        if (groupRight.right & 1)
          this.selectedFileTreeList.push(
            this.fileTreeRightTranslate.findIndex(
              f => f[0] == groupRight.FileTreeId && f[1] == 1
            )
          );
        if (groupRight.right & 2)
          this.selectedFileTreeList.push(
            this.fileTreeRightTranslate.findIndex(
              f => f[0] == groupRight.FileTreeId && f[1] == 2
            )
          );
        if (groupRight.right & 4)
          this.selectedFileTreeList.push(
            this.fileTreeRightTranslate.findIndex(
              f => f[0] == groupRight.FileTreeId && f[1] == 4
            )
          );
      }
    },
    async showError(message) {
      this.snackbar.color = "error";
      this.showMessage(message);
    },
    async showSuccess(message) {
      this.snackbar.color = "success";
      this.showMessage(message);
    },
    async showInfo(message) {
      this.snackbar.color = "info";
      this.showMessage(message);
    },
    async showMessage(message) {
      this.snackbar.message = message;
      this.snackbar.on = true;
    }
  },
  async mounted() {
    this.groupInfo.color = this.Rules.colors[
      Math.floor(Math.random() * this.Rules.colors.length)
    ];
    await this.getData();
    this.createNavigation();
    this.createFolderList();
  }
};
</script>

